import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Select } from 'redpoints-front-components/index';
import { withPriorities } from 'redpoints-front-common/components';

import { allIncidentsFiltersSetPriorityId } from '../../../actions/allIncidentsActions';
import { getAllIncidentsFiltersPriorities } from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsFiltersPriority = ({
  allIncidentsFiltersSetPriorityId,
  arePrioritiesLoaded,
  getPrioritiesAsArray,
  prioritiesSelected,
}) => {
  const priorities = getPrioritiesAsArray().map(
    ({ priorityId, literalKey }) => ({
      key: priorityId,
      value: translate(literalKey),
    })
  );
  const handlePrioritySelect = priorityId =>
    allIncidentsFiltersSetPriorityId({ priorityId });

  return (
    <Select
      allowClear
      data={priorities}
      disabled={!arePrioritiesLoaded}
      label={translate('reporting.allIncidentsInternal.filters.priorityLevel')}
      mapping={{ key: 'key', value: 'value' }}
      mode="multiple"
      onChange={handlePrioritySelect}
      placeholder={translate('common.all')}
      showSearch
      value={prioritiesSelected || undefined}
    />
  );
};

const mapStateToProps = state => ({
  prioritiesSelected: getAllIncidentsFiltersPriorities(state),
});

export default compose(
  withPriorities,
  connect(mapStateToProps, {
    allIncidentsFiltersSetPriorityId,
  })
)(AllIncidentsFiltersPriority);
